export default "__VITE_ASSET__CvI3fkB0__"